export default {
  "custom": {
    linkedReference: '連動参照',
    boot: '電源ON',
    shutDown: '電源OFF',
    notLinked: '未連動',
    maxLinkedTip: '{type}連動は最大2つまでです。未連動に自動的に戻しました',

    bar_Power: '電源制御',
    bar_Video: '映像切り替え',
    bar_Vol: '音量',
    bar_Audio: 'オーディオ',
    bar_Serial: 'シリアル制御',
    bar_Air: 'エアコン',
    bar_Projection: 'スクリーン',
    bar_Remote: 'リモコン',
    bar_Matrix: 'IQShare Matrix',
    "youMustSelectAllThreeImagesAtTheSameTime": "3つの画像すべてを同時に選択する必要があります",
    "notSelected": "未選択",
    "choose": "選択",
    "disable": "無効",
    "longPressAndDrag": "長押ししてドラッグし、リストの順序を調整",
    "isrestoreDefault": "デフォルト状態に戻しますか？",
    "saveAndSync": "保存して同期",
    "restoreDefault": "デフォルトを復元",
    "limitPNG": "PNG画像のみアップロード可能です！",
    "limit1M": "画像サイズは1MBを超えないでください！",
    "selectTheImage": "画像を選択",
    "textsuggestions": "推奨：48*48 px、1MB以下の白いPNGアイコン",
    "iconLibrary": "アイコンライブラリ",
    "panelNavigationBarCustomization": "パネルナビゲーションバー",
    "logoCustomization": "パネルロゴ"
  },
  "outlook": {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    "AuthVerify4004One": "バインドに失敗しました: このMicrosoftテナント（ID: ",
    "AuthVerify4004Two": "）は既に組織[",
    "AuthVerify4004Three": "]によって使用されています。再バインドするには、まず元の組織から解除するか、別のMicrosoftテナントを使用してください。",
    "theMicrosoftTenantIsOccupied": "このMicrosoftテナントは使用中です",
    "Viewtutorial": "バインディングチュートリアルを見る",
    "checktenantID": "テナントID、アプリケーションID、およびアプリケーションキーが正しいか確認してください。",
    "ErrorCode": "エラーコード：",
    "AuthorizationFailed": "認証に失敗しました",
    "Accesshasbeengranted": "Microsoft Graph APIへのアクセスが許可されました",
    "successfullyauthorizedDescribe": "必要な権限は正常に認可されました。会議室データは自動的に同期されます。このページを閉じてください。",
    "Close": "閉じる",
    "resourceID": "リソースID",
    "dialogTips": "ヒント",
    "theAuthorizationIsDeleted": "認可が削除されました",
    "theBindingIsSuccessful": "バインド成功",
    "theUnbindingIsSuccessful": "アンバインド成功",
    "unbindingFailed": "アンバインド失敗",
    "theUnbindingHasBeenUnbound": "アンバインドキャンセル",
    "continueUnbinding": "Outlookの同期は停止し、今後のイベントはすべてクリアされます。アンバインドを続行しますか？",
    "areYouSureAboutUnbinding": "今後のOutlookイベントはすべてクリアされ、同期は停止します。この操作は元に戻せません。アンバインドを確認しますか？",
    "UnbindNotSynchronized": "バインド後、この部屋の新しいOutlookイベントは自動的に同期されます（過去のイベントは同期されません）",
    "unbinding": "アンバインド",
    "bindUnableToSelect": "すでにバインド済みで、選択できません",
    "permissAThird": "サードパーティリソースをバインドするには認可してください",
    "resourceMailbox": "リソースメール：",
    "PleasecheckID": "認可に失敗しました！テナントID、アプリケーションID、およびクライアントシークレットが正しいか確認してください。",
    "Waitingforauthorization": "認可待機中...",
    "Pleasecompletetheauthorization": "Microsoft 365ログインページが開きました。管理者アカウントでサインインして認可を完了してください。",
    "pleaseEnterTheTenantID": "テナントIDを入力してください",
    "pleaseEnterTheClientID": "アプリケーションIDを入力してください",
    "pleaseEnterTheClientSecret": "クライアントシークレットを入力してください",
    "Authorizationcompleted": "認可完了",
    "Authorizelogin": "Microsoft 365ログインを認可",
    "ApplicationID": "テナントID",
    "ClientID": "アプリケーションID",
    "ClientSecret": "クライアントシークレット",
    "registTipOne": "以下に従ってください",
    "registTipTwo": "バインディングガイド",
    "registTipThree": "以下のフィールドに入力する前に、Azureアプリ登録と権限設定を完了してください。",
    "MicrosoftDescribe": "Microsoft 365をバインドすることで、Outlook/Teamsで予約された会議をQ-NEXコンソールおよびルームスケジューラに自動同期できます。",
    "Addcalendarservice": "カレンダー同期設定",
    "Lasttimesynchronization": "最終同期時間",
    "Allocated": "割り当て済み",
    "Total": "合計",
    "Conferenceroomresources": "会議室リソース",
    "Bindingtime": "バインド時間",
    "Bindtheplatform": "バインドプラットフォーム",
    "Synchronousstate": "同期ステータス",
    "Organizationname": "組織名",
    "Bindthirdpartycalendar": "サードパーティカレンダーをバインド",
    "TenantIDTip": "Azure AD内の一意の識別子",
    "ApplicationIDTip": "Azureで登録されたアプリケーションID",
    "ApplicationSecretTip": "認証用にAzureで生成されたクライアントシークレット"
  },
  "meetingManager": {
    IdleDisplayTextTable: '待機表示テキスト',
    IdleDisplayText: '待機表示テキスト：',
    IdleDisplayTextContent: '会議室が空いているときに表示するテキスト（デフォルト：「空室」）',

    duplicateMeetingRoomName: '会議室名が重複しています',
    duplicateMeetingRoomNameContent: '「{duplicate_content}」という名前の会議室は既に存在します。別の名前を入力してください。',
    "NumberOfRoomPanels": "ルームパネルの数",
    "Thecurrentterminalhasbeenboundtoanotherorganization": "現在の端末はすでに別の組織にバインドされています。",
    "theTerminalNameOrIDIsDuplicated": "パネル名またはIDが同じです",
    theRoomNameOrIDIsDuplicated: '会議室名または場所が重複しています。',
    "AddMeetingRoom": "会議室を追加",
    "EditMeetingRoom": "会議室を編集",
    "MeetingRoomName": "会議室名：",
    "Location": "場所：",
    "ReservationApproval": "予約承認：",
    "ApprovalListYes": "はい",
    "ApprovalListNo": "いいえ",
    "Capacity": "収容人数：",
    "RoomStatus": "部屋の状態：",
    "BindRoomDisplay": "ルームパネルをバインド：",
    "meeting_btnAdd": "追加",
    "meeting_btnEdit": "編集",
    "meeting_btnBind": "デバイスをバインド",
    "meeting_btnDel": "削除",
    "meeting_tableRoomName": "会議室名",
    "meeting_tableRoomPlace": "場所",
    "meeting_tableAppointmentApproval": "予約承認",
    "meeting_tableCapacityForPeople": "収容人数",
    "meeting_tableMeetingRoomStatus": "部屋の状態",
    "meeting_tableAvaliable": "利用可能",
    "meeting_tableOutofService": "サービス停止中",
    "meeting_tableDoorBind": "ドアバインド",
    "meeting_tableBindNPS": "NPSをバインド",
    "meeting_tableActions": "操作",
    "door_theNameOfTheTerminal": "パネル名：",
    "door_deviceID": "パネルID：",
    "door_Wallpaper": "壁紙：",
    "door_Wallpaper_text": "推奨画像: サイズ1280x800、PNG形式",
    "door_bindAMeetingRoom": "会議室をバインド：",
    "door_table_name": "パネル名",
    "door_table_deviceID": "パネルID",
    "door_table_status": "ステータス",
    "door_table_ipAddress": "IPアドレス",
    "door_table_bindAMeetingRoom": "会議室をバインド",
    "door_btnAdd": "追加",
    "door_btnBatchAdd": "一括追加",
    "door_btnEdit": "編集",
    "door_btnBatchEdit": "一括編集"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "構成追加",
    "configurationEditTitle": "構成編集",
    "dialogConfigName": "構成名",
    "selectNMPAndNDP": "対象デバイス",
    "powerControl": "電源制御",
    "executeCommand": "実行",
    "tableConfigName": "構成名",
    "selectConfig": "構成を選択してください"
  },
  "NPS": {
    "Relay": "リレー",
    "RelaySettings": "リレー設定",
    "DevicePower": "デバイス電源制御",
    "DeviceElevation": "昇降制御",
    "LinageWithNPSPower": "NPS電源との連動",
    "PresentationSwitch": "プレゼンテーションスイッチ",
    "Duplicate": "複製",
    "LinkagewithNPSPowe": "NPS電源との連動"
  },
  "PTZ": {
    "powerSupplyON": "電源オン",
    "powerSupplyOFF": "電源オフ",
    "LEFT": "左",
    "RIGHT": "右",
    "UP": "上",
    "DOWN": "下",
    "HOME": "ホーム",
    "ENLARGE": "拡大",
    "REDUCTION": "縮小",
    "StopMovement": "動作停止",
    "STOP": "ズーム停止",
    "FOCUS": "フォーカス",
    "SET_PRESETS0": "プリセット0設定",
    "SET_PRESETS1": "プリセット1設定",
    "SET_PRESETS2": "プリセット2設定",
    "SET_PRESETS3": "プリセット3設定",
    "SET_PRESETS4": "プリセット4設定",
    "SET_PRESETS5": "プリセット5設定",
    "SET_PRESETS6": "プリセット6設定",
    "SET_PRESETS7": "プリセット7設定",
    "SET_PRESETS8": "プリセット8設定",
    "SET_PRESETS9": "プリセット9設定",
    "USE_PRESETS0": "プリセット0使用",
    "USE_PRESETS1": "プリセット1使用",
    "USE_PRESETS2": "プリセット2使用",
    "USE_PRESETS3": "プリセット3使用",
    "USE_PRESETS4": "プリセット4使用",
    "USE_PRESETS5": "プリセット5使用",
    "USE_PRESETS6": "プリセット6使用",
    "USE_PRESETS7": "プリセット7使用",
    "USE_PRESETS8": "プリセット8使用",
    "USE_PRESETS9": "プリセット9使用"
  },
  "schedule": {
    "startLinkPowerStart": "電源オン（CBXリレー）",
    "startLinkPowerStop": "電源オフ（CBXリレー）",
    "dehumidification": "除湿",
    "airSupply": "送風",
    "masterControl": "メイン：",
    "powerSupply": "電源",
    "lockScreen": "ロック",
    "RecordingControl": "録画制御",
    "RecordingControlSystem": "講義キャプチャシステム",
    "LiquidCrystal": "インタラクティブフラットパネル",
    "projector": "プロジェクター",
    "othertype": "その他",
    "childLock": "チャイルドロック",
    "energySaving": "省エネ",
    "signalSourceSwitching": "入力ソース",
    "other": "その他の機能：",
    "otherFunction": "機能",
    "send": "送信",
    "ON": "オン",
    "OFF": "オフ",
    "btnAddSchedule": "復元",
    "EditSchedulelist": "スケジューラー編集",
    "AddSchedulelist": "スケジューラー追加",
    "RestoreSchedulelist": "復元",
    "btn": "キャンセル",
    "btnNewList": "新しいスケジューラー",
    "ListName": "名前",
    "Cannotquit": "必須",
    "NOCannotquit": "いいえ",
    "ListValidityPeriod": "有効期間",
    "ListDescription": "説明",
    "currentSchedule": "スケジューラーリスト",
    "historySchedule": "履歴リスト",
    "selectTime": "時間",
    "taskType": "タスクタイプ",
    "selectBroadcasting": "放送",
    "selectDeviveControl": "デバイス制御",
    "newSchedule": "新しいタスク",
    "newChecklist": "新しいチェックリスト",
    "titleStatus": "ステータス",
    "titleType": "種類",
    "titleStartTime": "開始時間",
    "titleEndTime": "終了時間",
    "titleRepeat": "繰り返し",
    "titleName": "名前",
    "titleAction": "操作",
    "tableEnabled": "有効",
    "tablePaused": "一時停止",
    "tableEdit": "編集",
    "tableDelete": "削除",
    "tableVolumeEdit": "放送音量",
    "tableBroadcastTitle": "タイトル",
    "tableBroadcastContent": "内容",
    "tableBroadcastList": "リスト",
    "tableBroadcast": "強制",
    "btnRemoveCompletely": "完全に削除",
    "btnEnabled": "有効なタスク",
    "btnPaused": "一時停止",
    "btnDelete": "削除",
    "repeat0": "月",
    "repeat1": "火",
    "repeat2": "水",
    "repeat3": "木",
    "repeat4": "金",
    "repeat5": "土",
    "repeat6": "日",
    "dialogTitleAdd": "新しいデバイス制御タスク",
    "dialogTitleEdit": "デバイス制御タスク編集",
    "newBroadcastingSchedule": "新しい放送タスク",
    "editBroadcastingSchedule": "放送タスク編集",
    "chooseDevice": "デバイスを選択",
    "timeSetting": "時間設定",
    "controlBroadcasting": "放送オプション",
    "controlOption": "制御オプション",
    "scheduleName": "タスク名：",
    "destination": "宛先",
    "timeTilte": "時間",
    "repeatTitle": "繰り返し",
    "dialogRepeat0": "月",
    "dialogRepeat1": "火",
    "dialogRepeat2": "水",
    "dialogRepeat3": "木",
    "dialogRepeat4": "金",
    "dialogRepeat5": "土",
    "dialogRepeat6": "日",
    "dialogOnceType": "一度",
    "dialogRepeatType": "繰り返し",
    "mainPower": "メイン電源",
    "powerControl": "電源制御",
    "tableDisplayInputSwitch": "表示入力切替",
    "tableAirConditioning": "エアコン",
    "tableProjectionScreen": "投影スクリーン",
    "tableElectronicLock": "電気ロック",
    "interactiveFlatPanel": "Interactive Flat Panel",
    "displayInputSwitch": "表示入力切替",
    "speakerVolume": "スピーカー音量",
    "MICVolume": "マイク音量",
    "ProjectionScreen": "投影スクリーン",
    "ElectronicLock": "電気ロック",
    "AirConditioning": "エアコン",
    "AirConditioningPower": "電源",
    "AirConditioningModel": "モデル",
    "AirConditioningTEMP": "温度",
    "AirConditioningFanSpeed": "ファンスピード",
    "OPEN": "開く",
    "CLOSE": "閉じる",
    "UP": "上",
    "DOWN": "下",
    "PowerOFF": "オフ",
    "PowerON": "オン",
    "ModelAuto": "自動",
    "ModelCool": "冷房",
    "ModelHeat": "暖房",
    "ModelAir": "送風口側",
    "TEMPLow": "低",
    "TEMPMiddle": "中",
    "TEMPHigh": "高",
    "btnSave": "保存",
    "btnNext": "次へ",
    "StartTime": "開始時間",
    "StopTime": "終了時間",
    "Mandatory": "必須",
    "Video": "映像＆音声",
    "Notification": "通知",
    "btnFile": "メディアファイルを選択",
    "LastingTime": "持続時間",
    "textTitle": "タイトル",
    "textContent": "内容",
    "textTitleLetters": "60文字未満",
    "textContentLetters": "320文字未満",
    "CannotquitYES": "はい",
    "CannotquitNo": "いいえ",
    "YES": "はい",
    "No": "いいえ",
    "delTitleContent": "このスケジューラを削除してもよろしいですか？",
    "delTitleListContent": "削除されたスケジューラは履歴リストに移動され、復元可能です",
    "deleListTitle": "スケジューラを削除しますか？",
    "delTitleListContent1": "スケジューラを削除すると関連するタスクも消去されます。確認してください。",
    "deleListTitle1": "このスケジューラを削除してもよろしいですか？",
    "delTitle": "削除？",
    "btnConfirm": "確認",
    "coxAll": "すべて",
    "coxBroadcasting": "放送",
    "coxDeviveControl": "デバイス制御",
    "rdMandatory": "はい",
    "noRdMandatory": "いいえ",
    "startDate": "開始日",
    "endedDate": "終了日",
    "or": "-",
    "broadcastingType": "タイプ",
    "ChooseTime": "時間を選択",
    "ChooseDate": "日付を選択",
    "newScheduleList": "新しいスケジューラ",
    "editScheduleList": "スケジューラ編集",
    "listName": "名前",
    "listValidityPeriod": "有効期間",
    "listDescription": "説明",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "addSuccess": "追加成功！",
    "addError": "追加失敗！",
    "editSuccess": "編集成功！",
    "editError": "編集失敗！",
    "delSuccess": "削除成功！",
    "delError": "削除失敗！",
    "restoreSuccess": "スケジュールリストを復元しました",
    "restoreError": "スケジュールリストの復元に失敗しました",
    "restoreTitleContent": "この時間はリスト内のスケジュールと重複しています。再選択してください",
    "Enabled": "有効",
    "Paused": "一時停止",
    "Title": "タイトル：",
    "Content": "内容：",
    "errorScheduleNameRequired": "タスク名を入力してください",
    "errorDeviceRequired": "対象デバイスを選択してください",
    "deleTitle": "このタスクを削除してもよろしいですか？",
    "loopList": "ループリスト",
    "errorPleaseDateRange": "日付範囲を選択してください",
    "addError_2009": "スケジューラ名が重複しています",
    "conflicts": "タスク時間が以下と重複しています：",
    "Pleaseagain": "再入力してください",
    "errorScheduleName": "タスク名",
    "errorListName": "スケジューラ名",
    "today": "今日",
    "yesterday": "昨日",
    "thisWeek": "今週",
    "lastWeek": "先週",
    "lastMonth": "先月",
    "thisMonth": "今月",
    "times": "回数",
    "TimeConflicts": "時間の重複",
    "editError_2006": "デバイスが見つかりません",
    "editError_2010": "タスク名が重複しています",
    "ListTimeExpired": "スケジューラ時間が期限切れです。再選択してください",
    "TimeExpired": "時間切れ",
    "ControlOption": "制御オプションがありません",
    "Pleaseleastone": "少なくとも1つの制御オプションを選択してください",
    "Enter": "入力",
    "TitleFilled": "タイトルは必須です",
    "ContentFilled": "内容は必須です",
    "PleaseMediaFile": "メディアファイルを選択してください",
    "PleaseSchedule": "タスクを選択してください",
    "delTitleScheduleContent": "削除されたタスクは復元できません",
    "deleTitleSchedule": "このタスクを削除してもよろしいですか？",
    "deleteScheduleTitle": "削除するタスクを選択してください",
    "PleaseFillColumn": "スケジューラ名を入力してください",
    "PleaseDate": "日付を選択してください",
    "Previous": "前へ",
    "RemoteControl": "リモコン",
    "taskhasexpired": "このタスクは期限切れです。作成者に時間を更新するよう連絡してください。",
    "execute": "実行",
    "broadcastingList": "放送リスト",
    "volumeSuccess": "音量設定成功",
    "volumeFailed": "音量設定失敗"
  },
  "Automation": {
    "nameDuplicate": "自動タスク名が重複しています",
    "Automation": "自動化",
    "if": "もし：",
    "ifContent": "「IF」セクションでは、センサーのデータに基づいて条件を設定できます。センサーを選択し、「温度 > 26°C」のような条件を指定してください。",
    "then": "その場合：",
    "thenContent": "「THEN」セクションでは、デバイスを選択してアクションを定義できます。NMP1、NMP2などのデバイスを選択し、エアコンの場合は「オン + 冷房」などのアクションを指定します。",
    "btnDelete": "削除",
    "Add": "追加",
    "taskName": "タスク名",
    "dialogTaskName": "タスク名：",
    "Statue": "ステータス",
    "DevicesApplied": "適用デバイス",
    "Operation": "操作",
    "AirConditioningPower": "電源",
    "AirConditioningModel": "モデル",
    "AirConditioningFanSpeed": "ファンスピード",
    "bold": "スイング",
    "selectTask": "タスクを選択してください",
    "autoTaskAdd": "自動化タスクを追加",
    "autoTaskEdit": "自動化タスクを編集",
    "Destination": "宛先",
    "selectConditions": "実行したいアクションを指定してください。",
    "selectDestination": "対象のNMPデバイスを選択し、実行したいアクションを指定してください",
    "AirConditioningTEMP": "温度",
    "AirConditioningHumidness": "湿度",
    "noData": "まだタスクが追加されていません。「追加」ボタンをクリックしてタスクを追加してください。"
  },
  "rs232Translation": {
    "reliveBinding": "バインド解除",
    "RELIVEBINDING": "バインド解除",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "CBX名を入力してください",
    "BrandNoNull": "ブランドを入力してください",
    "ModelNoNull": "モデルを入力してください",
    "AcNoNull": "エアコン制御を入力してください",
    "RcNoNull": "リモコンを入力してください"
  },
  "route": {
    "customize": "カスタマイズ",
    "InputSourcesLinkage": "入力ソース連携",
    "Automation": "自動化",
    "dashboard": "Dashboard",
    "i18n": "I18n",
    "organizationMge": "グループ",
    "userMge": "ユーザー",
    "authorityMge": "権限",
    "roleMge": "役割",
    "equipmentMge": "デバイス",
    "workstationMge": "メディアサーバー",
    "cloudDiskMge": "ストレージ管理",
    "operationLog": "操作ログ",
    "setting": "設定",
    "resourceMge": "リソース管理",
    "storageMge": "ストレージ管理",
    "interfaceRename": "インターフェイス名変更",
    "processorManager": "プロセッサーマネージャー",
    "projectorCode": "シリアルコード管理",
    "projectorCodeSetting": "シリアルコード設定",
    "RepairLog": "修理ログ",
    "remoteControl": "リモコンコード",
    "acCode": "エアコン制御コード",
    "cardMge": "カード",
    "cardLog": "カード使用ログ",
    "cardManager": "カードマネージャー",
    "meetingManager": "会議",
    "meetingRoomManager": "部屋管理",
    "meetingDoorManager": "パネル管理"
  },
  "navbar": {
    "logOut": "ログアウト",
    "dashboard": "ダッシュボード",
    "screenfull": "全画面表示",
    "language": "言語",
    "userConsole": "Q-NEX コンソール",
    "BackTianwa": "天和に戻る"
  },
  "feedback": {
    "Feedback": "フィードバック",
    "email": "フィードバックのためにメールアドレスを入力してください。",
    "content": "製品改善のためのメッセージを歓迎します。ご意見ありがとうございます。",
    "submit": "送信",
    "emailNoEmpty": "メールアドレスを入力してください",
    "emailTrueRule": "正しいメール形式を入力してください",
    "contentNoEmpty": "内容を入力してください",
    "feedbackSuccess": "フィードバック成功",
    "feedbackFailed": "フィードバック失敗",
    "emailNoChinese": "メールアドレスに中国語文字を含めることはできません",
    "emailLength": "5〜100文字の間で入力してください",
    "GroupNameLength": "1〜20文字の間で入力してください",
    "emailSpecialString": "この入力欄には特殊文字を含めることはできません"
  },
  "login": {
    "title": "ようこそ",
    "logIn": "ログイン",
    "username": "ユーザー名",
    "password": "パスワード",
    "any": "任意",
    "thirdparty": "または以下で接続",
    "thirdpartyTips": "ローカルではシミュレーションできません。独自の業務シミュレーションを組み合わせてください！",
    "placeholder": "[\r\n  \"ユーザー名\",\r\n  \"パスワード\",\r\n  \"認証コード\"\r\n]",
    "userNameTitle": "ユーザー名が間違っています！",
    "forget": "忘れましたか？",
    "loginTitle0": "ログイン成功！",
    "loginTitle1000": "ユーザー名またはパスワードが間違っています！",
    "loginTitle1001": "ユーザー名とパスワードを入力してください！",
    "loginTitle1002": "認証コードを入力してください！",
    "loginTitle1003": "ユーザーの状態が不正で、ログインできません！",
    "loginTitle1004": "認証コードエラー！",
    "loginTitle1005": "ログインしていません。まずログインしてください！",
    "loginTitleUserName": "ユーザー名を入力してください！",
    "loginTitlePwd": "パスワードを入力してください！",
    "loginTitleVercode": "認証コードを入力してください！",
    "errorLogin": "ユーザー権限が不足しており、ログインできません！",
    "titleLoginNameFormat": "文字のみ、または文字と数字で構成する必要があります。"
  },
  "organizationMge": {
    "CanTDragTop": "ルートに移動できません",
    "prefixCannotBeEmpty": "スーパ管理者アカウントの接頭辞は空にできません",
    "enterEnglishLetters": "スーパ管理者アカウントの接頭辞は英字と数字のみ入力可能です",
    "dateNotSelected": "ストリーミングサービスの有効期間の開始日が選択されていません",
    "btnAddChild": "部下を追加",
    "btnAddSibling": "兄弟を追加",
    "title": "ヒント：",
    "againTitle": "再確認してください：",
    "sort": "並び替え：",
    "realName": "本名：",
    "titleShooleRq": "この項目は必須です",
    "titleShooleNub": "100文字未満",
    "schoolName": "グループ名：",
    "type": "グループタイプ：",
    "accountPrefix": "管理者アカウント：",
    "organization": "配布者",
    "terminalMechanism": "エンドユーザー",
    "equipmentNum": "デバイス番号：",
    "organizationNum": "端末グループ番号：",
    "adminName": "管理者アカウント：",
    "adminPwd": "管理者パスワード：",
    "edit": "編集",
    "add": "追加",
    "del": "削除",
    "addSuccess": "追加成功",
    "addError": "追加失敗！",
    "editSuccess": "変更成功",
    "editError": "変更失敗！",
    "delSuccess": "削除成功！",
    "delWarn": "バインドされたデバイスがあるグループは削除できません",
    "delError": "削除失敗！",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "TrialWorkstation": "現在、試用状態で、最大3端末までしか放送・ライブ配信をプッシュできません。",
    "Normal": "通常",
    "NormalWorkstation": "ストリーミングサービスの有効期間は以下の通りです",
    "to": "まで",
    "Advent": "開始  ",
    "AdventWorkstationOne": "ストリーミングサービスは に期限切れになります",
    "AdventWorkstationTwo": "通常利用のため、期限内に代理店に更新依頼をしてください。  ",
    "Expired": "期限切れ  ",
    "ExpiredWorkstation": "ストリーミングサービスの期限が切れました。代理店に更新依頼をしてください。  ",
    "admin": "管理者：  ",
    "serviceState": "ストリーミングメディアサービス：  ",
    "serviceStateLIST": "ストリーミングメディアサービス  ",
    "ValidityPeriod": "有効期間：  ",
    "ValidityPeriodLIST": "有効期間  ",
    "Trial": "試用  ",
    "Permanent": "永久  ",
    "AnnualBilling": "年間請求  ",
    "mediaValidityPeriod": "有効期間：  ",
    "mediaValidityPeriodLIST": "有効期間  ",
    "contactInformation": "連絡先（ストリーミングサービス更新通知用）  ",
    "company": "会社名：  ",
    "email": "メール：  ",
    "phone": "電話：  ",
    "StartDate": "開始日  ",
    "EndDate": "終了日",
    "To": "まで",
    "TerminalName": "エンドユーザー名  ",
    "Competence": "管理者  ",
    "operate": "操作  ",
    "statusFilter": "ステータスフィルター  ",
    "disableStreaming": "ストリーミングサービスを無効にしてもよろしいですか？  ",
    "enableStreaming": "ストリーミングサービスを有効にしてもよろしいですか？  ",
    "disableStreamingContent": "ストリーミングサービスが無効になると、グループは放送およびライブ放送関連の機能を使用できません。  ",
    "enableStreamingContent": "有効期限が切れたグループの有効期間を変更してください。  ",
    "search": "組織名を入力してください  ",
    "optionsYearZero": "選択してください  ",
    "optionsYearOne": "1年  ",
    "optionsYearTwo": "2年  ",
    "optionsYearThree": "3年  ",
    "dialogName": "名前：  ",
    "detTitle": "グループを削除すると、その下のすべてのコンテンツも削除されます。  ",
    "groupDelTitle": "このグループを削除してもよろしいですか？  ",
    "delTitle": "削除？  ",
    "delTitleContent": "選択した内容はデータベースから削除されます。この操作は元に戻せません。続行してもよろしいですか？  ",
    "delCancelButton": "キャンセル  ",
    "delConfirmButton": "確認  ",
    "copySuccess": "内容がクリップボードにコピーされました。  ",
    "copyError": "ブラウザは自動コピーをサポートしていません  ",
    "error1200": "グループ名が重複しています  ",
    "error1201": "グループまたはグループIDが重複しています  ",
    "error1202": "接続可能なデバイス数の上限を超えました  ",
    "error1203": "ユーザー名が重複しています  ",
    "error1204": "同じ階層に同名のグループがあります  ",
    "error1210": "管理者パスワードを入力してください  ",
    "warningGroup": "グループを選択してください！  ",
    "warningTerminal": "端末グループはサブグループを作成できません！  ",
    "account": "アカウントが重複しています  ",
    "titleOrganization": "注意：アカウントのプレフィックスは組織レベルで定義されています。この組織内のすべてのユーザーアカウントは同じプレフィックスを共有します。",
    "all": "すべて"
  },
  "userMge": {
    "nickName": "ニックネーム  ",
    "contentWithBrand": "ブランドまたはモデルを入力  ",
    "contentwithIp": "デバイス名またはIPアドレスで検索  ",
    "btnAdd": "新規ユーザー  ",
    "btnDelete": "削除  ",
    "btnDownload": "テンプレートをダウンロード  ",
    "btnImport": "一括インポート  ",
    "btnExport": "ダウンロード  ",
    "btnDisable": "無効  ",
    "btnEnable": "有効  ",
    "accountType": "役割でフィルター  ",
    "organizationName": "グループでフィルター  ",
    "content": "検索  ",
    "systemAccount": "ユーザーID  ",
    "idCardNumber": "従業員ID  ",
    "customizeAccount": "カスタムアカウント  ",
    "userName": "名前  ",
    "licenseNum": "ライセンス番号  ",
    "phone": "電話番号  ",
    "email": "メール  ",
    "role": "役割  ",
    "status": "ステータス  ",
    "affiliatedOrganization": "グループ  ",
    "roleTypeList1": "一般ユーザー  ",
    "roleTypeList2": "学生  ",
    "roleTypeList3": "保護者  ",
    "roleTypeList101": "エージェント管理者  ",
    "roleTypeList102": "管理者  ",
    "roleTypeList301": "スーパ管理者  ",
    "userStatus1": "アクティブ  ",
    "userStatus2": "ブロック  ",
    "userStatus3": "削除  ",
    "operate": "操作  ",
    "dialogName": "ニックネーム：  ",
    "dialogUserName": "ユーザーID：  ",
    "dialogUserNameDefined": "ユーザー名：  ",
    "dialogPassword": "パスワード：  ",
    "dialogID": "従業員ID：  ",
    "dialogRole": "役割：  ",
    "dialogEmail": "メール：  ",
    "dialogPhone": "電話番号：  ",
    "dialogGroup": "グループ：  ",
    "addUser": "新規ユーザー  ",
    "editUser": "ユーザー編集  ",
    "addSuccess": "追加成功！  ",
    "addError": "追加失敗！  ",
    "editSuccess": "編集成功！  ",
    "editError": "編集失敗！  ",
    "delSuccess": "削除成功！  ",
    "delError": "削除失敗！  ",
    "cancel": "キャンセル  ",
    "confirm": "確認  ",
    "save": "保存  ",
    "tableDel": "削除  ",
    "tableEdit": "編集  ",
    "selectRoles": "役割を選択  ",
    "delTitle": "削除？  ",
    "delTitleContent": "選択した内容はデータベースから削除されます。この操作は元に戻せません。本当に続行しますか？  ",
    "delCancelButton": "キャンセル  ",
    "delConfirmButton": "確認  ",
    "titleRealNameRq": "この項目は必須です  ",
    "titleRealNameFormat": "英数字のみを含むユーザー名を選択してください。  ",
    checkPasswordTitleTwo: '6文字以上で、英字と数字を含むパスワードを設定してください。特殊文字も使用可能です（制限なし）。',
    checkPasswordTitle: 'パスワードは6文字以上で、数字のみは不可です',
    "titlePhoneFormat": "電話番号は数字、()、+、- のみ入力可能です。  ",
    "phoneFilled": "電話番号は必須です。  ",
    "titleEmaileFormat": "メール形式が正しくありません。  ",
    "emaileFilled": "メールは必須です。  ",
    "titlUserNameDefinedNub": "ユーザー名は30文字以内で入力してください  ",
    "titlRealNameNub": "名前は30文字以内で入力してください。  ",
    "titlRealNameField": "名前は必須です。  ",
    "thisPasswordField": "パスワードは必須です。  ",
    "titlPassWordNub": "パスワードは6～30文字で入力してください  ",
    "enableStatus": "ユーザーを有効化  ",
    "stopStatus": "ユーザーを無効化  ",
    "enableContent": "本当にユーザーを有効化しますか？  ",
    "stopContent": "本当にユーザーを無効化しますか？  ",
    "error1400": "ユーザー名は既に存在します。再試行してください  ",
    "error1401": "ユーザーIDは既に存在し、操作に失敗しました！  ",
    "error1402": "グループが存在せず、インポートに失敗しました！  ",
    "error1403": "データが正しくありません  ",
    "error1404": "権限不足  ",
    "selUser": "ユーザーを選択してください！  ",
    "error1405": "役割取得に失敗しました  ",
    "error1406": "インポートしたユーザー情報のデータ形式が正しくありません  ",
    "error1407": "メールは既に存在し、操作に失敗しました。  ",
    "error1408": "電話番号は既に存在し、操作に失敗しました。  ",
    "error1900": "アクセスしたパラメータが空です  ",
    "error1610": "関連操作を行うには端末管理者の役割を使用してください  ",
    "errorOrgIdList": "グループは空にできません！  ",
    "Bindsucceeded": "バインド成功  ",
    "Bindfailed": "バインド失敗  ",
    "tableuserName": "ユーザー名  ",
    "titleDevice": "デバイス  ",
    "bindDevice": "デバイスをバインド  ",
    "Bindcontrollable": "制御可能なデバイスを今すぐバインドしますか？"
  },
  "devicesMge": {
    "mustChooseOne": "スマートリモコンが選択されている場合、少なくとも1つの制御コマンドを選択する必要があります  ",
    "customName": "カスタム名  ",
    "testAcCode": "新しいA/C制御コードをテスト  ",
    "Online": "オンライン  ",
    "Offline": "オフライン  ",
    "unBindConfirm": "シリアルのバインドを解除しますか？  ",
    "unBindConfirm485": "RS485のバインドを解除しますか？  ",
    "notYetBoundRS232": "デバイスはまだシリアルコードにバインドされていません。[デバイス > シリアル制御コード]で追加できます。  ",
    "RsFollowingFunctions": "シリアルコードを通じて以下の機能を実現できます：  ",
    "Unbind": "バインド解除  ",
    "Limit255": "ファイル名は最大255文字です  ",
    "clear": "クリア  ",
    "equipName": "デバイス名  ",
    "equipType": "種類  ",
    "selectField": "ファイルを選択してください  ",
    "dialogTip": "*右側の入力欄が空の場合、左側の内容がデフォルトで表示されます  ",
    "dialogTipSingle": "*単一デバイスに名前がない場合は「ALL」の名前に従います",
    "cantDelTemplateOne": "「 」のCBX",
    cantDelTemplateTwo: 'デバイス「{deviceName}」配下のCBXはテンプレートです。削除してもよろしいですか？',
    "templateTitle": "テンプレートの置き換え",
    "templateContentOne": "デバイス名「",
    "templateContentTwo": "\"は共通CBXテンプレートとして設定されています。現在のデバイスをテンプレートとして設定してもよろしいですか？",
    "vcbNoTemplateNoSave": "テンプレートなしでは保存できません",
    "vcbAcControl": "A/Cデバイスを選択",
    "vcbRemoteControl": "リモートコントロールデバイスを選択",
    "vcbPOWERControl": "電源制御",
    "vcbRS232Control": "シリアル制御",
    "vcbIRControl": "IR制御",
    "vcbSetting": "CBX設定",
    "editVcb": "CBXを編集",
    "vcbName": "CBX名",
    "iot": "CBX制御",
    "saveAsTemplate": "テンプレートとして保存",
    saveAsTemplatereplenish: 'コントロールセンターでこのテンプレートを使用するデバイスを複数選択してください',
    "Upload": "アップロード",
    "Select": "選択",
    "InputDeviceID": "デバイスIDを入力",
    "editNameTips": "* 右側の入力欄が空の場合、左側の内容がデフォルトで表示されます。",
    "_RS232A": "インターフェース1",
    "_RS232B": "インターフェース2",
    "institutionDirectory": "機関ディレクトリ",
    "projectionScreenLinkageSetting": "投影スクリーン制御設定",
    "screenLiftingLinkageDisplaySwitch": "投影スクリーンとディスプレイ連動制御:",
    "stopLinkage": "無効（投影スクリーンを個別に制御）",
    "Enable": "有効（投影スクリーンとディスプレイを同期制御）",
    "btnAddDevice": "デバイスを追加",
    "btnImportDevice": "デバイスを一括インポート",
    "btnDel": "削除",
    "btnEdit": "編集",
    "tableIpAddress": "IPアドレス",
    "MACAddress": "MACアドレス",
    "firmwareVersion": "ファームウェアバージョン",
    "NA": "該当なし",
    "tableDeviceName": "デバイス名",
    "tableStatus": "ステータス",
    "tableVideoSwitch": "ビデオスイッチ",
    "tableAudio": "A/V分配",
    "tablePowerControl": "電源制御",
    "tableRS232": "シリアル制御",
    "tableIR": "IR制御",
    "tableRFIDCard": "ICカード",
    "tableControlPanel": "コントロールパネル",
    "tableOrganization": "グループ",
    "tableActions": "操作",
    "dialogAddTitle": "デバイスを追加",
    "dialogEditTitle": "デバイスを編集",
    "dialogBatchAddTitle": "デバイスを一括追加",
    "dialogBatchEditTitle": "デバイスを一括編集",
    "btnCancel": "キャンセル",
    "Devices": "デバイス:",
    "ProjectorCode": "シリアルコード:",
    "Group": "グループ:",
    "btnBatchAdd": "一括追加",
    "delTitle": "削除?",
    "delTitleContent": "選択したコンポーネントはデータベースから削除されます。この操作は元に戻せません。続行してよろしいですか？",
    "delCancelButton": "キャンセル",
    "delConfirmButton": "確認",
    "addError": "追加失敗!",
    "editSuccess": "編集成功!",
    "editError": "編集失敗!",
    "delSuccess": "削除成功!",
    "delError": "削除失敗!",
    "content": "検索",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "tableDel": "削除",
    "tableEdit": "編集",
    "selectRoles": "役割を選択",
    "selectType": "タイプを選択してください",
    "selectDevices": "デバイスを選択してください",
    "titleRealNameRq": "この項目は必須です",
    "titleRealNameNub": "100文字以内",
    "titlPassWordNub": "15文字以内",
    "error1900": "アクセスしたパラメータが空です",
    "error2000": "接続可能なデバイスの最大数を超えました",
    "error2001": "インポートされたデバイスコードが間違っているか、まだシステムに登録されていません。",
    "error2002": "重複したデバイス名がインポートされました",
    "error2003": "インポートされたデバイスIDはすでに使用されています",
    "error2004": "データインポートエラー",
    "error2005": "ブランド名またはモデル名が既存データと重複しています。ブランド名またはモデル名を変更してください。",
    "error2008": "このデバイスはすでに別のグループに関連付けられています",
    "notDevicesName": "デバイス名を空にすることはできません",
    "notDevicesNO": "デバイスIDを空にすることはできません",
    "dialogDevicesName": "デバイス名：",
    "dialogDevicesID": "デバイスID：",
    "dialogProjectorCode": "シリアルコード：",
    "dialogGroup": "グループ：",
    "dialogSel": "選択してください",
    "errorOrgIdList": "グループは空にできません！",
    "errorDevicesName": "デバイス名を空にすることはできません！",
    "errorDevicesNo": "デバイスIDを空にすることはできません！",
    "dialogTiltleDevices": "デバイス：",
    "uploadSuccess": "アップロード成功",
    "addSuccess": "追加成功",
    "ChooseGroups": "グループを選択",
    "ChooseIcon": "アイコンを選択",
    "dialogDevicesTitle": "パラメータ設定は以下のデバイスに適用されます",
    "backDevice": "戻る",
    "bootSetting": "起動オプション",
    "nmpOpenSetting": "電源オン設定",
    "npsOpenSetting": "電源オン設定",
    "nmpPowerSettings": "電源設定",
    "npsPowerSettings": "電源設定",
    "nmpInterfaceSettings": "インターフェース設定",
    "npsInterfaceSettings": "インターフェース設定",
    "nmpDefaultChannel": "デフォルトチャンネル設定",
    "nmpCloseSetting": "電源オフ設定",
    "npsCloseSetting": "電源オフ設定",
    "SwipeToStart": "ロックを有効にする（カードでタップして解除）",
    "ControlPanelToStart": "ロックを無効にする（無制限操作）",
    "Display": "ディスプレイ",
    "External": "外部",
    "startingUpMethod": "パネルロックの有効/無効：",
    "startWith": "開始時：",
    "nmpstartWith": "電源オン同期：",
    "nmpcloseWith": "電源オフ同期：",
    "RS232Tip": "メイン電源がオフのとき、Serialインターフェース5つ（Serial + 最大4 CBX）に対応するシャットダウンコマンドが送信されます",
    "startPowerTip": "電源オン時、CBX電源ポートに接続された全デバイスがオンになります。",
    "startAirTip": "電源オン時、すべての紐づけられたエアコンがデバイス/CBXからの赤外線信号でオンになります。",
    "startIrTip": "電源オン時、コマンド（例：スクリーン巻き上げ、プロジェクターオフ）がデバイス/CBXからの赤外線信号で送信されます。",
    "startRSTip": "電源オン時、電源オンコマンドはデバイス/CBXのSerialポートから送信されます。",
    "CloseDisplayTip": "DISPLAYポートに接続されたディスプレイは、NDP/NMPがシャットダウンすると自動的にオフになります。この設定はファームウェアで管理され、ソフトウェアから変更できません。",
    "CloseExternalTip": "EXTERNALポートに接続されたデバイスは、NDP/NMPがシャットダウンすると自動的にオフになります。この設定はファームウェアで管理され、ソフトウェアから変更できません。",
    "ClosePowerTip": "シャットダウン時、CBX電源ポートに接続された全デバイスがオフになります。",
    "CloseAirTip": "シャットダウン時、すべての紐づけられたエアコンがデバイス/CBXからの赤外線信号でオンになります。",
    "CloseIrTip": "シャットダウン時、コマンド（例：スクリーン巻き上げ、プロジェクターオフ）がデバイス/CBXからの赤外線信号で送信されます。",
    "CloseRSTip": "シャットダウン時、シャットダウンコマンドはデバイス/CBXのSerialポートから送信されます。",
    "npsOpenRS232Tip": "メイン電源がオンのとき、NPSの2つのSerialポートが対応する電源オンコマンドを受信します。",
    "npsRS232Tip": "メイン電源がオフのとき、NPSの2つのSerialインターフェースが対応するシャットダウンコマンドを受信します。",
    "useCardTip": "カード解除後、デバイスの電源が自動的にオンになります。",
    "npsCardTip": "カード解除後、デバイスのメイン電源が自動的にオンになります。",
    "PowerOutageHandling": "停電時の対応",
    "PowerOutageHandTip": "予期しない停電中にアクセスを継続するには、「停電時に解除」を選択してください。それ以外の場合は「停電時にロック」を選択してアクセスを制限します",
    "acSetting": "A/C 設定",
    "ChooseType": "デバイスタイプ",
    "ChooseBrand": "ブランドを選択",
    "ChooseModel": "モデルを選択",
    "btnConnectingTest": "接続テスト",
    "LockSetting": "電気錠設定",
    "ElectricLockType": "電気錠タイプ：",
    "PowerUNLOCK": "停電時解除",
    "PowerLOCK": "停電時施錠",
    "none": "なし",
    "oddParity": "奇数パリティ",
    "EvenParity": "偶数パリティ",
    "LastSetting": "最終設定",
    "ElectricLockClosing": "電気錠閉鎖：",
    "manualSwitch": "手動スイッチ",
    "Auto": "自動 (in",
    "projectorSetting": "デバイス選択とバインド",
    "baudRate": "ボーレート",
    "Parity": "パリティ",
    "ON": "電源オン",
    "OFF": "電源オフ",
    "Channel1": "チャンネル1",
    "Channel2": "チャンネル2",
    "PowerOffDelay": "電源オフ遅延",
    "second": "秒",
    "DefaultChannel": "デフォルトチャンネル",
    "HDMIA": "HDMI 出力 A:",
    "HDMIB": "HDMI 出力 B:",
    "HDMIC": "HDMI 出力 C:",
    "btnSaveApply": "保存して適用...",
    "btnSave": "保存",
    "btnCustomize": "カスタム",
    "ACIsPowerTitle": "A/C の電源がオンか確認しますか？",
    "ACIsPowerContent": "テスト前に A/C をオフにしてください。正常にオンにならない場合、A/C のブランドとモデルが正しいことを確認してください。",
    "btnNextModel": "いいえ、次のモデルをテスト",
    "btnYes": "はい",
    "errorConnecting": "接続テスト失敗",
    "hot": "ホット",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "電子ロック",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AUDIOA": "HDMI out A",
    "_AUDIOB": "Audio IN 1",
    "_AUDIOC": "Audio IN 2",
    "_AIR": "エアコン",
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "赤外線制御設定",
    "acControlTitle": "A/C デバイスを選択：",
    "acControlTitleNew": "A/C デバイス",
    "intelligentControlTitle": "リモコンデバイスを選択：",
    "intelligentControlTitleNew": "リモコンデバイス",
    "btnACControlCode": "新しい A/C 制御コードを識別",
    "btnAddRemoteControl": "新しいリモコンコード",
    "ACControlCodeTitle": "A/C 制御コードを識別",
    "ACControlCodeseft1": "コードを識別",
    "ACControlCodeseft2": "情報を追加",
    "btnStartIdentify": "開始",
    "Identifysuccess": "識別成功！",
    "BeingIdentify": "分析中...",
    "acBrand": "A/C ブランド",
    "acModel": "A/C モデル",
    "IdentifyFailureTitle": "コードが見つかりませんでした",
    "IdentifyFailureContent": "識別に失敗しました。このモデルは現在サポートされていません。リモコンを試してください",
    "btnTryAgain": "再試行",
    "btnJump": "リモコンに移動",
    "ACrideo": "A/C",
    "ortherRideo": "その他のデバイス",
    "btnBack": "戻る",
    "btnSortOut": "編集に移動",
    "remoteControlSeft1": "デバイスタイプを選択",
    "remoteControlSeft2": "コードを学習",
    "remoteControlSeft3": "情報を追加",
    "addRemoteControlError": "申し訳ありません、これ以上コードを学習できません。既存のリモコンコードを先に編集してください",
    "btnPrevious": "前",
    "btnNextStep": "次",
    "remoteControlErrorTitle": "コードの学習に失敗しました",
    "remoteControlErrorContent1": "1. 赤外線送信機が遮られていない",
    "remoteControlErrorContent2": "2. 受信機周辺に強い光干渉がない",
    "remoteControlErrorContent3": "3. 赤外線送信機が正しく設置されている",
    "remoteControlErrorContent4": "4. リモコンが正常に動作している",
    "deviceItem1": "A/C",
    "deviceItem2": "プロジェクター",
    "deviceItem3": "テレビ",
    "deviceItem4": "扇風機",
    "deviceItem5": "照明",
    "deviceItem6": "その他",
    "deviceItem7": "インタラクティブフラットパネル",
    "deviceItem8": "講義キャプチャシステム",
    "deviceItem9": "PTZ カメラ",
    "RS232protocol": "シリアルプロトコル：",
    "btnRemoteControl": "学習開始",
    "BeingIdentify1": "分析中...",
    "Identifysuccess1": "成功",
    "controllerType1": "A/C",
    "controllerType2": "シリアル",
    "controllerType3": "テレビ",
    "controllerType4": "扇風機",
    "controllerType5": "照明",
    "controllerType9": "その他",
    "rqRemoteControlCode": "リモコンコード名を入力してください",
    "rqBrand": "A/C のブランドを入力してください",
    "rqModel": "A/C のモデルを入力してください",
    "error2016": "リモコン名が重複しています。別の名前を入力してください",
    "RS232Setting": "シリアルコード設定",
    "IR232Setting": "IR 設定",
    "SystemError": "システムエラー。もう一度お試しください",
    "conditionerCodeContent": "エアコンコードが見つかりません。もう一度お試しください",
    "remoteControlCodeContent": "リモコンコードが見つかりません。もう一度お試しください",
    "btnRetry": "再試行",
    "Bindusers": "ユーザーをバインド",
    "tablebinduser": "ユーザーをバインド",
    "Refresh": "更新",
    "Binduserlable": "今すぐデバイスを操作できるユーザーをバインドしますか？",
    "SaveApplySuccessfully": "保存して適用成功",
    "DeviceType": "タイプ：",
    "tableDeviceType": "タイプ",
    "empty": "空です。",
    "sendCommand": "後で送信",
    "enable": "有効化",
    "disable": "無効化",
    "SYNCremoteControl": "リモコンと同期",
    "analysisfailed": "分析に失敗しました。もう一度お試しください！",

    "CBX": {
      "powerSupplyON": "電源オン",
      "powerSupplyOFF": "電源オフ",
      "powerVcrON": "録画開始",
      "powerVcrOFF": "録画停止",
      "lockScreenON": "ロックオン",
      "lockScreenOFF": "ロックオフ",
      "childLockON": "チャイルドロックオン",
      "childLockOFF": "チャイルドロックオフ",
      "energySavingON": "省エネオン",
      "energySaving": "省エネ",
      "energySavingOFF": "省エネオフ",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "スピーカー",
      "brightAdjustment": "明るさ",
      "other": "その他の機能…",
      "volumeExample": "録画システムとの完全互換のためには、RS232制御機能が必要です。",
      "functionCode": "機能：",
      "Name": "名前：",
      "controlCode": "制御コード：",
      "brand": "ブランド：",
      "model": "モデル：",
      "errorBrandName": "ブランドを入力してください！",
      "errorModelName": "モデルを入力してください！"
    }
  },
  "roleMge": {
    "role1": "一般ユーザー",
    "role101": "エージェント管理者",
    "role102": "管理者",
    "role4": "カスタム役割",
    "roleNew": "新しい役割",
    "btnAddRole": "役割を追加",
    "chooseUser": "ユーザーを選択",
    "titleLevel": "放送プロパティレベル：",
    "titleSettings": "権限設定：",
    "btnSave": "保存",
    "btnDelete": "削除",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "addSuccess": "追加成功！",
    "addError": "追加に失敗しました！",
    "editSuccess": "編集成功！",
    "editError": "編集に失敗しました！",
    "delSuccess": "削除成功！",
    "delError": "削除に失敗しました！",
    "V3_0_OrganizationManage": "グループ管理",
    "V3_0_UserManage": "ユーザー管理",
    "V3_0_DeviceManage": "デバイス管理",
    "V3_0_CloudSpaceManage": "クラウドスペース管理",
    "V3_0_OrganizationManage_View": "表示",
    "V3_0_OrganizationManage_Edit": "編集",
    "V3_0_UserManage_View": "表示",
    "V3_0_UserManage_Edit": "編集",
    "V3_0_DeviceManage_AddDevice": "デバイスを追加",
    "V3_0_DeviceManage_Operating": "操作",
    "V3_0_DeviceManage_Delete": "削除",
    "V3_0_DeviceManage_Edit": "編集",
    "V3_0_CloudSpaceManage_PersonalManage": "個人クラウド管理",
    "V3_0_CloudSpaceManage_PublicManage": "公共クラウド管理",
    "V3_0_CloudSpaceManage_SpaceManage": "スペース割り当て",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "操作",
    "V3_0_CloudSpaceManage_PersonalManage_View": "表示",
    "V3_0_CloudSpaceManage_PublicManage_View": "表示",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "アップロード",
    "V3_0_CloudSpaceManage_PublicManage_Download": "ダウンロード",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "ファイルを削除",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "フォルダを編集",
    "delTitle": "削除？",
    "delTitleContent": "選択した内容はデータベースから削除されます。この操作は元に戻せません。本当に続行しますか？",
    "delCancelButton": "キャンセル",
    "delConfirmButton": "確認",
    "btnAdd": "役割を追加",
    "RoleName": "役割名：",
    "ManageRange": "管理範囲：",
    "ChooseUser": "ユーザーを選択：",
    "PermissionSettings": "権限設定：",
    "BroadcastingPropertyLevel": "放送プロパティレベル",
    "ChooseGroups": "グループを選択",
    "ChooseTheUser": "ユーザーを選択",
    "deleleTitle": "新しい役割は保存されていません。ページを離れると役割は削除されます。本当に離れますか？",
    "Error1601": "管理者は使用できません",
    "Error1602": "権限役割の取得に失敗しました",
    "Error1603": "この機能には管理者のみアクセス可能です",
    "Error1604": "役割名は空にできません",
    "Error1605": "グループは空にできません",
    "Error1606": "この役割は既に存在します",
    "Error1607": "システム定義の役割は変更できません",
    "Error1608": "役割設定に失敗しました",
    "Error1609": "システム共通ユーザー役割は変更できません",
    "Error1610": "関連操作は端末管理者権限で実行してください",
    "Error1611": "関連する役割権限がありません"
  },
  "projectorDevicesMge": {
    "tipOne": "1.機能名と制御コードを入力してください。制御コードの例はHEX形式です。",
    "tipTwo": "2.この界面は電源ON/OFFシリアルコマンドの設定のみを行います。機能を有効にするには「デバイス管理/デバイス/操作/電源設定」を参照してください。",
    "tipFunctionOne": "1. ドロップダウンリストから一般的な機能を選択してください。対応するアイコンがスマートパネルのシリアル制御界面に表示されます。",
    "tipFunctionTwo": "2. 「POWER ON」および「POWER OFF」コマンドはデバイスの電源ON/OFFシリアル連携に使用されます。このページは制御コードのみを設定します。連携機能を有効にするには「デバイス管理/デバイス/操作/電源設定」を参照してください。",
    "ListRS232functions": "シリアル制御機能リスト",
    "Customizefunctionlist": "機能リストをカスタマイズ",
    "btnAddProjectorCode": "シリアルコードを追加",
    "btnDel": "削除",
    "inputSeach": "検索",
    "btnEdit": "編集",
    "cancel": "クリア",
    "confirm": "確認",
    "tableName": "コード名",
    "tablersType": "デバイスタイプ：",
    "tablersTypeTable": "デバイスタイプ",
    "tableModel": "モデル",
    "tableBrand": "ブランド",
    "tableActions": "操作",
    "dialogAddTitle": "シリアルコードを追加",
    "dialogEditTitle": "シリアルコードを編集",
    "brand": "ブランド名：",
    "model": "モデル：",
    "baudRate": "ボーレート：",
    "parity": "パリティ：",
    "powerOn": "オン",
    "powerOff": "オフ",
    "pgrInput1": "チャンネル1",
    "pgbInput2": "チャンネル2",
    "delTitle": "削除？",
    "delTitleContent": "選択した内容はデータベースから削除されます。この操作は元に戻せません。本当に続行しますか？",
    "delCancelButton": "キャンセル",
    "delConfirmButton": "確認",
    "content": "検索",
    "operate": "操作",
    "tableDel": "削除",
    "tableEdit": "編集",
    "addSuccess": "追加成功！",
    "addError": "追加に失敗しました！",
    "editSuccess": "編集成功！",
    "editError": "編集に失敗しました！",
    "delSuccess": "削除成功！",
    "delError": "削除に失敗しました！",
    "selectTitle": "シリアルを選択してください！",
    "selectCode": "シリアルを選択",
    "none": "なし",
    "oddParity": "奇数パリティ",
    "EvenParity": "偶数パリティ"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "グループ管理",
    "V3_0_UserManage": "ユーザー管理",
    "V3_0_DeviceManage": "デバイス管理",
    "V3_0_CloudSpaceManage": "クラウドスペース管理",
    "V3_0_OrganizationManage_View": "表示",
    "V3_0_OrganizationManage_Edit": "編集",
    "V3_0_UserManage_View": "表示",
    "V3_0_UserManage_Edit": "編集",
    "V3_0_DeviceManage_AddDevice": "デバイスを追加",
    "V3_0_DeviceManage_Operating": "操作",
    "V3_0_DeviceManage_Delete": "削除",
    "V3_0_DeviceManage_Edit": "編集",
    "V3_0_DeviceManage_RepairLog": "修理ログ",
    "V3_0_CloudSpaceManage_PersonalManage": "個人クラウド管理",
    "V3_0_CloudSpaceManage_PublicManage": "パブリッククラウド管理",
    "V3_0_CloudSpaceManage_SpaceManage": "クラウドスペース管理",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "操作",
    "V3_0_CloudSpaceManage_PersonalManage_View": "表示",
    "V3_0_CloudSpaceManage_PublicManage_View": "表示",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "アップロード",
    "V3_0_CloudSpaceManage_PublicManage_Download": "ダウンロード",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "削除",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "編集",
    "delTitle": "削除？",
    "delTitleContent": "選択したコンポーネントはデータベースから削除されます。この操作は元に戻せません。本当に続行しますか？",
    "delCancelButton": "キャンセル",
    "delConfirmButton": "確認",
    "content": "検索",
    "operate": "操作",
    "tableDel": "削除",
    "tableEdit": "編集",
    "addSuccess": "追加成功！",
    "addError": "追加に失敗しました！",
    "editSuccess": "編集成功！",
    "editError": "編集に失敗しました！",
    "delSuccess": "削除成功！",
    "delError": "削除に失敗しました！",
    "selectTitle": "シリアルを選択してください！"
  },
  "workstationMge": {
    "priorChoice": "放送設定：",
    "SpeedPriority": "速度優先",
    "SyncPriority": "フレーム同期優先",
    "SpeedPriorityTip": "AV放送指示が送信された後、Q-NEX端末は約3～5秒のバッファ時間で再生タスクを実行できます。メディアサーバーがLANで動作する場合、速度優先が強く推奨されます。",
    "SyncPriorityTip": "AV放送指示が送信された後、Q-NEX端末は約8～12秒のバッファ時間で同期的に再生タスクを実行できます。",
    "btnAddMedia": "メディアサーバーを追加",
    "btnBack": "戻る",
    "tableMediaLibId": "メディアサーバーID",
    "tableMediaLibName": "メディアサーバー名",
    "tableState": "ネットワーク状況",
    "tableBindingUsers": "バインディングユーザー",
    "tableLiveAddress": "ストリーミングアドレス",
    "tableAddress": "放送アドレス",
    "tableOperate": "操作",
    "tableDel": "削除",
    "tableEdit": "編集",
    "titleMediaStation": "放送アドレス",
    "titleLiveStation": "ストリーミングアドレス：",
    "radioPublic": "パブリック",
    "radioPrivate": "プライベート",
    "btnSave": "保存",
    "titleUsers": "ユーザー",
    "titleCanBe": "バインド可能",
    "titleHaveBeen": "既にバインド済み",
    "titleMore": "さらに追加が必要ですか？",
    "btnAdd": "追加",
    "content": "検索",
    "tableName": "名前",
    "tableUserName": "ユーザー名",
    "operate": "操作",
    "affiliatedOrganization": "グループ",
    "dialogTitle": "新しいメディアサーバーを追加",
    "dialogTitleEdit": "新しいメディアサーバーを編集",
    "dialogItemName": "名前：",
    "dialogItemId": "ID：",
    "dialogItemIp": "放送アドレス：",
    "titleSelectUsers": "ユーザーを選択",
    "selectMedia": "メディアを選択してください",
    "delTitle": "本当に削除しますか？",
    "delMediaLibTitle": "削除確認？",
    "delTitleContent": "選択した内容はデータベースから削除されます。この操作は元に戻せません。本当に続行しますか？",
    "delTitleMediaLibContent": "削除操作により関連データが消去され、復元できません。",
    "delCancelButton": "キャンセル",
    "delConfirmButton": "確認",
    "selectDevices": "デバイスを選択してください",
    "selectUser": "ユーザーを選択してください",
    "addUser": "ユーザーを追加",
    "editUser": "ユーザーを編集",
    "addSuccess": "追加成功！",
    "addError": "追加に失敗しました！",
    "editSuccess": "編集成功！",
    "editError": "編集に失敗しました！",
    "delSuccess": "削除成功！",
    "delError": "削除に失敗しました！",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "error2500": "現在の作業ステーションに接続できるデバイスの最大数を超えています。",
    "DeviceName": "デバイス名",
    "AssociatedUserManagement": "関連ユーザー管理",
    "btnDel": "削除",
    "errorMsgId": "このIDが見つかりません",
    "LiveStreaming": "ストリーミングアドレス：",
    "NoFoundMediaId": "メディアサーバーのIDを取得できません",
    "AlreadyConnectedOrg": "メディアサーバーは既に別の組織に関連付けられています",
    "AlreadyBoundMedia": "この組織はすでにメディアサーバーをバインドしており、さらにバインドできません",
    "DeleteSecondaryConfirmation": "メディアサーバーを削除するとデータは復元できません。再度確認してください。"
  },
  "cloudDiskMge": {
    "totalStorage": "合計ストレージ",
    "GetMore": "さらに取得",
    "StorageSpace": "ストレージ容量",
    "Adjustment": "調整",
    "moreSpace": "ストレージ容量をさらに取得",
    "PublicStorage": "パブリックストレージ",
    "PublicStorageUsed": "使用済みパブリックストレージ",
    "PublicStorageLasted": "残りパブリックストレージ",
    "IndividualStorageUsed": "使用済み個人ストレージ",
    "IndividualStorageLasted": "残り個人ストレージ",
    "storageSpace": "ストレージ容量の調整",
    "tableUserName": "ユーザー名",
    "tableUsedSpace": "使用容量",
    "tableAvailableSpace": "利用可能容量",
    "tableActiveTime": "最終アクティブ時間",
    "tableOperate": "操作",
    "cleanup": "クリーンアップの注意",
    "IndividualStorageSpaceAdjustment": "個人ストレージ容量の調整",
    "titleTotal": "合計",
    "PublicDisk": "パブリッククラウド",
    "IndividualDisk": "個人クラウド",
    "PerUser": "ユーザーごと",
    "UsersInTotal": "総ユーザー数",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "addSuccess": "追加成功！",
    "addError": "追加失敗！",
    "editSuccess": "編集成功！",
    "editError": "編集失敗！",
    "delSuccess": "削除成功！",
    "delError": "削除失敗！",
    "error3000": "ストレージ総容量を超えたため操作に失敗しました。",
    "error3003": "操作失敗、メディアサーバーが設定されているか確認してください。",
    "IndividualStorage": "個人ストレージ",
    "NoteToCleanup": "クリーンアップの注意",
    "updatePersonalSuccess": "クラウドストレージ容量が満杯です。時間内に整理してください",
    "updatePersonalSuccess1": "変更を保存しました",
    "storageUsage": "個人ストレージの使用状況",
    "bindIndividualstorage": "個人クラウドストレージを持つことが許可されたユーザー",
    "UserIndividualstorage": "すでに個人クラウドストレージが設定されているユーザー",
    "Notificationsuccessfully": "通知送信成功",
    "Notificationfailed": "通知送信失敗",
    "tableName": "名前",
    "userID": "ユーザーID"
  },
  "dashboard": {
    "exportPdf": "PDFをエクスポート",
    "or": "-",
    "warrantyCompletionRate": "修理完了率",
    "frequencyOfEachModule": "各機能モジュールの修理パーセンテージ",
    "repairHandling": "修理の処理状況",
    "sourceSwitchInput": "入力切替",
    "micVol": "マイク音量",
    "volumeSpeaker": "スピーカー音量",
    "airAonditioner": "エアコン",
    "Curtain": "プロジェクタースクリーン",
    "remoteControlIntelligent": "リモコン",
    "RS232Control": "シリアル制御",
    "lockElectronic": "電子ロック",
    "Repairreportcompleted": "修理済み",
    "Totalnumberofrepairsreported": "総修理件数",
    "Warrantycompletionrate": "修理完了率",
    "startDate": "開始日",
    "endDate": "終了日",
    "year": "年",
    "month": "月",
    "dayTian": "日",
    "placeholderDate": "日付を選択",
    "placeholderDateTime": "時間を選択",
    "devicesNub": "デバイス",
    "userNub": "ユーザー",
    "powerNub": "電力(KW/H)",
    "storageUsed": "使用済みストレージ(%)",
    "userLoginDevice": "ユーザーログインアクティブ期間",
    "devicePowerConsumption": "全デバイスの1日あたり電力消費量",
    "externalDeviceUsageTime": "外部デバイス使用状況",
    "equipmentRunningTime": "端末デバイス使用状況",
    "cloudStorageSpace": "ストレージ使用量",
    "powerConsumptionPort": "各電源ポートの消費電力",
    "mostPopularFile": "最も人気のあるファイル",
    "commonFunctions": "一般的な機能",
    "commonlyUsed": "よく使われる放送方法",
    "fileName": "ファイル名",
    "usageCount": "使用回数",
    "electricityConsumption": "電力消費量",
    "publicStorageUsed": "使用済みパブリックストレージ",
    "publicStorageLasted": "残りパブリックストレージ",
    "individualStorageUsed": "使用済み個人ストレージ",
    "individualStorageLasted": "残り個人ストレージ",
    "notification": "通知",
    "audioBroadcast": "音声放送",
    "videoBroadcast": "ビデオ放送",
    "ac": "エアコン",
    "hDMISwitch": "HDMI切替",
    "powerControl": "電源制御",
    "powercontrol": "電源制御",
    "Lock": "ロック",
    "volumeAdjust": "音量調整",
    "projectionScreen": "投影スクリーン",
    "today": "今日",
    "yesterday": "昨日",
    "thisWeek": "今週",
    "lastWeek": "先週",
    "lastMonth": "先月",
    "thisMonth": "今月",
    "times": "回数",
    "usage": "使用回数",
    "eachrTitle": "分",
    "total": "合計",
    "NMPSystemissue": "NMPシステム問題",
    "displayPower": "NMP外部デバイス問題",
    "externalPower": "MBXシステム問題",
    "screen": "MBX外部デバイス問題",
    "TotalRepairs": "総修理件数",
    "Repaired": "修理済み",
    "Unrepaired": "未修理",
    "day": "日",
    "Minutes": "分",
    "powerConsumption": "分",
    "Date": "日付",
    "kw": "KW",
    "month1": "MON",
    "month2": "TUE",
    "month3": "WED",
    "month4": "THU",
    "month5": "FRI",
    "month6": "SAT",
    "month7": "SUN",
    "enmonth1": "Jan",
    "enmonth2": "Feb",
    "enmonth3": "Mar",
    "enmonth4": "Apr",
    "enmonth5": "May",
    "enmonth6": "Jun",
    "enmonth7": "Jul",
    "enmonth8": "Aug",
    "enmonth9": "Sep",
    "enmonth10": "Oct",
    "enmonth11": "Nov",
    "enmonth12": "Dec",
    "noData": "データなし"
  },
  "input": {
    "fivedigits": "5桁以内の正の整数を入力してください",
    "titlUserNameField": "このユーザー名は必須です。",
    "thisField": "この項目は必須です。",
    "ChooseGroup": "グループを選択",
    "placeholder": "選択",
    "placeholder_type": "デバイス制御タイプを選択してください",
    "titlRealNameField": "パスワードは必須です。",
    "thisPasswordField": "パスワードは必須です。",
    "titlPassWordNub": "15文字未満",
    "Post": "数字のみ",
    "passwordNoChinese": "この入力欄には日本語文字を入力できません"
  },
  "transfer": {
    "all": "すべて",
    "Choose": "選択",
    "Selected": "選択済み",
    "Subordinate": "部下"
  },
  "setting": {
    limitPngGif: 'PNG / GIF形式のみ対応しています',
    limit3M: '画像サイズは3MB以下にしてください',
    setting_door_Wallpaper_text: '推奨画像サイズ：1280x800、PNGまたはGIF形式',

    "reduction": "復元",
    "limitJpg": "アップロードされたプロフィール画像はPNG形式のみ対応しています！",
    "limit2M": "アップロードされたプロフィール画像のサイズは2MBを超えることはできません！",
    "choseFile": "ファイルを選択",
    "textOne": "1. 推奨LOGO画像: サイズ117*40、PNG形式",
    "textTwo": "2. アップロード完了後、タッチパネルに移動し、タッチパネルがインターネットに接続されていることを確認してから、元のロゴをクリックして更新してください。",
    "customizeLogo": "タッチパネルロゴ設定",
    "addSuccess": "設定成功！",
    "settingIp": "ファイル保存先IP設定",
    "ServerIP": "サーバーIPアドレス：",
    "ServerPort": "サーバーポート：",
    "btnSave": "保存",
    "TimeZoneSetting": "タイムゾーン設定",
    "CurrentTime": "現在時刻：",
    "CurrentTimeZone": "現在のタイムゾーン：",
    "httpsSetting": "ファイル保存：",
    "utcName": "グリニッジ標準時 UTC/GMT",
    "utc0": "グリニッジ標準時、英国、リスボン、トルシャウン、ロンドン、ダブリン、エディンバラ",
    "utc0_5": "",
    "utc1": "中央ヨーロッパ、西アフリカ、西中央アフリカ、ドイツ、アイルランド、フランス、アムステルダム、イタリア、ベルリン、ローマ、スペイン、プラハ、ベオグラード、ブリュッセル、パリ、マドリード、チュニジア、ガボン、モロッコ",
    "utc1_5": "",
    "utc2": "東ヨーロッパ、中央アフリカ、トルコ、イスラエル、南アフリカ、イスタンブール、カイロ、アテネ、ダマスカス",
    "utc2_5": "",
    "utc3": "東アフリカ、ロシア、バグダッド、クウェート、モスクワ、サンクトペテルブルク",
    "utc3_5": "イラン",
    "utc4": "アブダビ、トビリシ、ドバイ、モーリシャス、ポートルイス",
    "utc4_5": "アフガニスタン",
    "utc5": "パキスタン、トルクメニスタン、モルディブ、ウズベキスタン、アルメニア、タジキスタン、インド（ムンバイ、新デリー、バンガロール、コルカタ）",
    "utc5_5": "インド、スリランカ",
    "utc6": "ノボシビルスク、キルギス、バングラデシュ、ブータン",
    "utc6_5": "ココス諸島、オーストラリア、ベトナム",
    "utc7": "タイ（バンコク）、ハノイ、ジャカルタ",
    "utc7_5": "",
    "utc8": "中国、マレーシア、フィリピン、シンガポール、台湾、中国（マカオ）、中国（香港）",
    "utc8_5": "",
    "utc9": "日本、韓国、東京、ソウル、札幌、大阪、東ティモール",
    "utc9_5": "オーストラリア中央標準時",
    "utc10": "オーストラリア、ウラジオストク、グアム、キャンベラ、メルボルン、シドニー、パプアニューギニア",
    "utc10_5": "ニューサウスウェールズ州ロードハウ島、オーストラリア",
    "utc11": "ソロモン諸島、サハリン島",
    "utc11_5": "ノーフォーク島、オーストラリア",
    "utc12": "ニュージーランド、オークランド、ウェリントン、フィジー、ニュージーランド、ナウル",
    "utc12_5": "",
    "utc13": "カーボベルデ、アゾレス",
    "utc13_5": "",
    "utc14": "サウスジョージア、フェルナンド・デ・ノローニャ",
    "utc14_5": "",
    "utc15": "ブラジル、サンティアゴ、エルサルバドル、ブラジリア、ウルグアイ、アルゼンチン、スリナム",
    "utc15_5": "ニューファンドランド標準時",
    "utc16": "ベネズエラ、ボリビア、パラグアイ、チリ",
    "utc16_5": "ベネズエラ",
    "utc17": "米国東部時間（米国・カナダ）、コロンビア、トロント、エクアドル、ペルー、キューバ、ニューヨーク、ハミルトン、サンディエゴ",
    "utc17_5": "",
    "utc18": "米国・カナダ中部時間、メキシコシティ、モンテレイ、シカゴ、ヒューストン、ニューオーリンズ、メンフィス",
    "utc18_5": "",
    "utc19": "山岳時間、アリゾナ州、マサトラン、フェニックス、ソルトレイクシティ、デンバー、エドモントン",
    "utc19_5": "",
    "utc20": "太平洋時間、ロサンゼルス、サンフランシスコ、バンクーバー、シアトル、ラスベガス",
    "utc20_5": "",
    "utc21": "アラスカ",
    "utc21_5": "フランス領ポリネシア、マルケサス諸島",
    "utc22": "ハワイ",
    "utc22_5": "",
    "utc23": "サモア、ニウエ",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "デバイス名：",
    "Time": "時間：",
    "startDate": "開始日",
    "endedDate": "終了日",
    "or": "-",
    "Problem": "問題：",
    "btnSearch": "検索",
    "tableNO": "いいえ",
    "tableDeviceName": "デバイス名",
    "tableGroup": "グループ",
    "tableStatus": "ステータス",
    "tableDeliveredTime": "配信時間",
    "tableSubmitter": "提出者",
    "tableUpdatingTime": "更新時間",
    "tableProblem": "問題",
    "tableAdmin": "IT管理者",
    "tableAdminReply": "管理者返信",
    "tableAttachment": "添付",
    "state0": "配信済み",
    "state1": "処理中",
    "state2": "完了",
    "Problem100": "すべて",
    "Problem0": "システム問題",
    "Problem1": "外部デバイス問題",
    "ProblemType": "",
    "ProblemType0": "電源制御",
    "ProblemType1": "HDMI切替",
    "ProblemType2": "マイク",
    "ProblemType3": "スピーカー",
    "ProblemType4": "エアコン",
    "ProblemType5": "プロジェクタースクリーン",
    "ProblemType6": "電子ロック",
    "ProblemType7": "A/V放送",
    "ProblemType8": "IR制御",
    "ProblemType9": "シリアル制御",
    "dialogDeviceName": "デバイス名",
    "dialogDeviceID": "デバイスID",
    "dialogGroup": "グループ",
    "dialogSubmitter": "提出者",
    "dialogStatus": "ステータスを選択",
    "dialogProblem": "問題",
    "dialogNotes": "メモ",
    "dialogRepairation": "修理",
    "dialogInProcess": "処理中",
    "dialogCompleted": "完了",
    "editSuccess": "編集成功！",
    "editError": "編集失敗！",
    "problemRequired": "問題タイプを選択してください",
    "detailRequired": "問題を詳しく説明してください",
    "statusRequired": "ログステータスを選択してください",
    "btnCancel": "キャンセル",
    "DeliveredTime": "配信時間",
    "UpdatingTime": "更新時間",
    "ITAdmin": "IT管理者",
    "AdminReply": "管理者返信",
    "Note": "ノート",
    "Detail": "詳細",
    "controlPanel": "コントロールパネル",
    "DeviceType": "タイプ",
    "dialogDeliveredTime": "配信時間",
    "Submitter": "提出者"
  },
  "remoteControl": {
    "QuickActionName": "名前",
    "DeviceType": "タイプ",
    "Description": "説明",
    "tableDescription": "説明",
    "editRemoteControl": "リモコンコードを編集",
    "QuickActionNameInput": "名前",
    "DescriptionInput": "説明",
    "save": "保存",
    "Brand": "ブランド",
    "Model": "モデル",
    "EditACControlCode": "エアコン制御コードを編集",
    "acBrand": "エアコンブランド",
    "acModel": "エアコンモデル"
  },
  "card": {
    "btnAddCard": "カード追加",
    "btnBatchAddCard": "カード一括追加",
    "tableCard": "カード番号",
    "tableState": "ステータス",
    "tableUser": "ユーザーに紐付け",
    "tableID": "ユーザー名",
    "tableType": "カードタイプ",
    "tableFfective": "有効期限",
    "dialogCard": "カード番号：",
    "dialogState": "ステータス：",
    "dialogUser": "ユーザーに紐付け：",
    "dialogID": "ユーザー名：",
    "dialogType": "カードタイプ：",
    "dialogFfective": "有効期限：",
    "dialogRemarks": "備考：",
    "dialogAddTitle": "カード追加",
    "dialogEidtTitle": "カード編集",
    "code2201": "カードの有効期限形式が正しくありません",
    "code2202": "このカードはすでに紐付けされています",
    "code2203": "このユーザーはすでに紐付けされています",
    "code2204": "このカードは紐付けされていません",
    "mastCard": "マスターカード",
    "regularCard": "一般カード",
    "permanent": "永久",
    "coxPermanent": "永久",
    "coxTime": "一定期間",
    "tableDeviceName": "デバイス名",
    "tableDeviceID": "デバイスID",
    "tableOperating": "操作",
    "tableOperatingTime": "操作時間",
    "tableCardID": "カード番号",
    "tableCardType": "カードタイプ",
    "tabluserName": "ユーザー名",
    "tabluserId": "ユーザーID",
    "unlockPanel": "パネル解錠",
    "unlock": "ドア解錠",
    "conAll": "すべて",
    "btnEnable": "有効化",
    "btnDisable": "無効化",
    "enableSuccess": "有効化成功",
    "stopSuccess": "無効化成功",
    "enableError": "有効化失敗",
    "stopError": "無効化失敗",
    "batchCard": "カード番号一括：",
    "titlCardField": "カード番号を入力してください",
    "titlCardFieldFormat": "英数字のみ",
    "dialogBachAddTitle": "カード一括追加",
    "pleaseTryAgain1": "カード番号が間違っています（NO.：",
    "pleaseTryAgain2": "）、再試行してください"
  },

  "privacy": {
    "PrivacyPolicy": "Microsoft Organization Binding Privacy Agreement",
    "Byusing": "Dear User,",
    "whatinformation": "Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking \"Agree,\" you confirm that you have read and accepted all terms of this agreement.",
    "EffectiveDate": "Effective Date: August 4, 2025",
    "title1": "Required Permissions & Collected Data",
    "title1Respects1": "To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:",
    "title1Respects2": "Delegated Permissions",
    "Respects2formation": "These permissions allow Q-NEX to access your Microsoft account data after login and consent:",
    "Respects2formation2": "Calendars.ReadWrite",
    "Respects2formation3": "Permission Name: Full access to user calendars",
    "Respects2formation4": "Description: Allows the app to create, read, update, and delete events in user calendars.",
    "Respects2formation5": "Purpose: Synchronize personal calendar meetings with the Q-NEX system.",
    "Respects2formation6": "offline_access",
    "Respects2formation7": "Permission Name: Maintain access to data you've granted",
    "Respects2formation8": "Description: Allows the app to access authorized data even when you're not actively using it.",
    "Respects2formation9": "Purpose: Ensures meeting information remains synced even when users are offline.",
    "Respects2formation10": "Openid",
    "Respects2formation11": "Permission Name: Sign in as you",
    "Respects2formation12": "Description: Enables login via work/school accounts and allows the app to read basic profile details.",
    "Respects2formation13": "Purpose: Authenticates user identity for security and associates profiles with meeting data.",
    "Respects2formation14": "Place.Read.All",
    "Respects2formation15": "Permission Name: Read all company places",
    "Respects2formation16": "Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.",
    "Respects2formation17": "Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.",
    "tp1": "Application Permissions (Requires Admin Consent)",
    "tp2": "These permissions enable Q-NEX to sync data automatically without manual reauthorization:",
    "tp3": "Calendars.ReadWrite",
    "tp4": "Permission Name: Read and write calendars in all mailboxes",
    "tp5": "Description: Allows the app to create, read, update, and delete calendar events without user sign-in.",
    "tp6": "Purpose: Syncs schedules from all company meeting room resource mailboxes.",
    "tp7": "Directory.Read.All",
    "tp8": "Permission Name: Read directory data",
    "tp9": "Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.",
    "tp10": "Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.",
    "tp11": "User.Read.All",
    "tp12": "Permission Name: Read all users' full profiles",
    "tp13": "Description: Allows the app to read user profiles without user sign-in.",
    "tp14": "Purpose: Identifies meeting participants.",
    "tp15": "Place.Read.All",
    "tp16": "Permission Name: Read all company places",
    "tp17": "Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.",
    "tp18": "Purpose: Retrieves full meeting room resource lists and syncs availability statuses.",
    "title2": "Purpose of Data Usage",
    "title2Respects1": "Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.",
    "title2Respects2": "Automatically update room availability to prevent scheduling conflicts.",
    "title2Respects3": "Provide a unified meeting management experience.",
    "title3": "Data Storage & Protection",
    "title3Respects1": "All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.",
    "title3Respects2": "Q-NEX does not share calendar data with third parties unless legally required or for system security.",
    "title3Respects3": "For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.",
    "title4": "Your Rights",
    "title4Respects1": "You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.",
    "title5": "Important Notes",
    "title5Respects1": "Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.",
    "title5Respects2": "Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.",
    "contactInformation": "Contact Information",
    "contactInformationContent": "If you have any questions, please contact: info@qnextech.com"
  }
}



// WEBPACK FOOTER //
// ./src/lang/ja.js